module.exports = __webpack_public_path__ + "img/05.b6b1d5dc.jpg";